import _slicedToArray from "/codebuild/output/src2648725416/src/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
export function toObjMap(obj) {
  if (obj == null) {
    return Object.create(null);
  }

  if (Object.getPrototypeOf(obj) === null) {
    return obj;
  }

  var map = Object.create(null);

  for (var _i = 0, _Object$entries = Object.entries(obj); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i2 = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i2[0],
        value = _Object$entries$_i2[1];

    map[key] = value;
  }

  return map;
}